export const SINGULARES: Record<string, string> = {
  'mujeres': 'mujer',
  'hombres': 'hombre',
  'ninos':   'nino',
  'ninas':   'nina',
};

/**
 * Devuelve true si la imagen pertenece al género indicado.
 * img.gender puede ser string o string[].
 */
export function imagenMatchGenero(img: any, genero: string): boolean {
  if (!img?.url) return false;

  const singular = SINGULARES[genero] ?? genero;

  // Sin campo gender → imagen legacy, se muestra siempre
  if (!img.gender) return true;

  // Normalizar a array
  const genders: string[] = Array.isArray(img.gender)
    ? img.gender
    : [img.gender];

  return genders.includes('unisex') ||
         genders.includes(genero) ||
         genders.includes(singular);
}

/**
 * Filtra el array de imágenes de un producto por género.
 */
export function filtrarImagenesPorGenero(images: any[], genero: string): any[] {
  if (!images?.length) return [];
  if (!genero) return images.filter(img => img?.url);
  return images.filter(img => imagenMatchGenero(img, genero));
}

/**
 * Devuelve la primera imagen que coincide con el género, o fallback a image[0].
 */
export function primeraImagenDelGenero(images: any[], genero: string, fallback: string = ''): string {
  const filtradas = filtrarImagenesPorGenero(images, genero);
  return filtradas[0]?.url || images?.[0]?.url || fallback;
}
